import { isNull, find, filter, includes } from 'lodash';

import { Nullable } from '~globals/types';
import { CapacityTypeBase } from '~services/capacityTypes/types';

export const findCapacityTypeById = (
  currentCapacityTypes: CapacityTypeBase[],
  capacityTypeIdToSearch: Nullable<number>,
): CapacityTypeBase | undefined => {
  if (isNull(capacityTypeIdToSearch)) {
    return undefined;
  }

  return find(currentCapacityTypes, {
    capacityTypeId: capacityTypeIdToSearch,
  });
};

export const getSuffixCapacity = (capacityType: CapacityTypeBase): string =>
  capacityType.suffix;

export const getDescriptionCapacity = (
  capacityType: CapacityTypeBase,
): string => capacityType.description;

export const parseCapacityValueWithSuffix = (
  currentValue: number | string,
  capacityType: CapacityTypeBase,
): string => `${currentValue} ${getSuffixCapacity(capacityType)}`;

export const excludeCapacityTypes = (
  currentCapacityTypes: CapacityTypeBase[],
  capacityTypeIdsToExclude: Nullable<number[]>,
): CapacityTypeBase[] => {
  if (
    isNull(capacityTypeIdsToExclude) ||
    capacityTypeIdsToExclude.length === 0
  ) {
    return [];
  }

  return filter(
    currentCapacityTypes,
    (currentCapacity) =>
      !includes(capacityTypeIdsToExclude, currentCapacity.capacityTypeId),
  );
};
